export default window.location.href.includes('localhost');
